import styled, { css } from 'styled-components';
import { InputTypes } from '../Input';
import NumberFormat from 'react-number-format';

export const Container = styled(NumberFormat)<{
  icon?: boolean;
  type: InputTypes;
}>`
${({ theme, icon, type }) => css`
  display: flex;
  flex-direction: column;

  display: flex;

  color: ${theme.colors.grey};

  height: 4rem;

  padding: 0.8rem 0.8rem;
  border: 0;
  background: ${theme.colors.lightGrey};

  border: solid 1px ${theme.colors.grey};

  font-size: ${theme.fontSizes.default};

  ${type === 'secondary' && css`
    border: 0px;
    padding: 1.2rem 0.8rem;
  `}

  border-radius: 0.8rem;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;

    ${icon && css`
      > svg {
        margin-right: 0.8rem;
      }
    `}

    > input {
      color: ${theme.colors.grey};
      height: 100%;
      width: 100%;

      border: 0;
      background: ${theme.colors.lightGrey};
      font-size: ${theme.fontSizes.default};
    }
  }

  > label {
    margin-bottom: 0.4rem;
  }

  ${type === 'quaternary' && css`
    border: 0px;
    background: transparent;
    padding: 0rem;

    > div {
      > input {
        background: transparent;
      }
    }

    border-bottom: solid 1px ${theme.colors.grey};
  `}
`}
`;
